import { Button, Tooltip } from "antd";
import classNames from "classnames";

import QuestionIcon from "assets/icons/QuestionIcon";

import styles from "./style.module.scss";

interface GuideButtonProps {
  onClick: () => void;
  tooltip: string;
  className?: string;
  inTitle?: boolean;
}

// Reopens a guide on demand. Never touches the "seen" flag.
const GuideButton = ({
  onClick,
  tooltip,
  className,
  inTitle,
}: GuideButtonProps) => (
  <Tooltip title={tooltip} placement="bottom" mouseEnterDelay={0.6}>
    <Button
      shape="circle"
      size="small"
      className={classNames(styles.helpButton, className, {
        [styles.inTitle]: inTitle,
      })}
      icon={<QuestionIcon />}
      onClick={onClick}
      aria-label="Open guide"
      data-testid="guide-button"
    />
  </Tooltip>
);

export default GuideButton;
